import React, { createContext, useState } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getVisitorAttendance } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";
export const VisitorsDetailContext = createContext({});

export const VisitorsDetailContextProvider = ({ children }) => {
  const location = useLocation();
  const vistorInfo = location?.state?.visitorInfo;
  const visitorId = location?.state?.visitorId;
  const [noEntryDetail, setNoEntryDetails] = useState(false);
  const [entryDetail, setEntryDetail] = useState([]);
  const [visiblePdfButton, setVisiblePdfButton] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [dataEntry, setDataEntry] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [modalIDPhotoOpenStatus, setModalIDPhotoOpenStatus] = useState(false);
  const [statusCode, setStatusCode] = useState(0);

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const callGetVisitorAttendance = async (visitorId) => {
    try {
      const getData = await getVisitorAttendance(visitorId);
      if (getData.data.status === 200) {
        setEntryDetail(getData?.data?.data?.docs);
        setDataEntry(getData?.data);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setAlertMessage("Something went wrong");
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const dataShown = () => {
    if (dataEntry <= 0) {
      setNoEntryDetails(true);
    } else {
      setNoEntryDetails(false);
    }
  };
  useEffect(() => {
    callGetVisitorAttendance(visitorId);
    dataShown();
  }, []);
  const providerValue = {
    visiblePdfButton,
    setVisiblePdfButton,
    goBack,
    vistorInfo,
    noEntryDetail,
    dataEntry,
    setNoEntryDetails,
    entryDetail,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    modalIDPhotoOpenStatus,
    setModalIDPhotoOpenStatus,
    logout,
    statusCode,
  };
  return (
    <VisitorsDetailContext.Provider value={providerValue}>
      {children}
    </VisitorsDetailContext.Provider>
  );
};
